import { Controller } from "@hotwired/stimulus";
import { hideAll } from "tippy.js";

export default class extends Controller {
  static targets = ["latestPageNumber"];

  /**
   * Returns the latest page number from the `latestPageNumber` target.
   */
  get latestPageNumber() {
    return this.latestPageNumberTarget.innerHTML.trim();
  }

  /**
   * Appends `latest_page_number` to a link's href's `next` query parameter.
   */
  appendLatestPageNumberToNextQueryString(event) {
    // Take next, change it, put it back in.
    const { currentTarget } = event;
    const url = new URL(currentTarget.href);

    let next = url.searchParams.get("next");
    next = decodeURIComponent(next);
    next = new URL(next);
    next.searchParams.delete("page");
    next.searchParams.set("latest_page_number", this.latestPageNumber);

    url.searchParams.set("next", next.href);
    currentTarget.href = url.href;
  }

  // eslint-disable-next-line class-methods-use-this
  closeAllTooltips() {
    hideAll();
  }
}
